import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';

import { AppComponent } from './app.component';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { LITE_USER_NAVIGATION_CONFIG, liteUserNavigationConfig } from './core/config/lite-user-navigation.config';
import { MEMBER_NAVIGATION_CONFIG, memberNavigationConfig } from './core/config/member-navigation.config';
import { NON_MEMBER_NAVIGATION_CONFIG, nonMemberNavigationConfig } from './core/config/non-member-navigation.config';
import { HttpRequestInterceptor } from './core/interceptors/http-request.intercepor';

import { CoreModule } from './core/core.module';

import './ui5-imports';

@NgModule({
  declarations: [AppComponent],
  imports: [CoreModule, AppRoutingModule, BrowserAnimationsModule, HttpClientModule],
  providers: [
    {
      provide: MEMBER_NAVIGATION_CONFIG,
      useValue: memberNavigationConfig(),
    },
    {
      provide: LITE_USER_NAVIGATION_CONFIG,
      useValue: liteUserNavigationConfig(),
    },
    {
      provide: NON_MEMBER_NAVIGATION_CONFIG,
      useValue: nonMemberNavigationConfig(),
    },
    { provide: HTTP_INTERCEPTORS, useClass: HttpRequestInterceptor, multi: true },
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  bootstrap: [AppComponent],
})
export class AppModule {}
